export enum MasterPairingSortBy {
  boardCreated = 'boardCreated',
  createdAt = 'createdAt',
  pairingDate = 'pairingDate',
  plusApplicationDate = 'plusApplicationDate',
  plusRenewalDate = 'plusRenewalDate'
}

export enum MasterPairingSortDirection {
  asc = 'asc',
  desc = 'desc'
}
